import { Grid, Paper, Button } from "@mui/material";
import React, { useState } from "react";
import "../../Styles/strategy.css";
import HeaderIcons from "../../Images/headericon.png";
import TransactionsTable from "../Tables/TransactionsTable";
import ManagerManagement from "../Tables/ManagerManagement";
import AddManager from "../../Modals/ManagerModals";

function Manager() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Grid item xs={12}>
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
          elevation={1}
        >
          <div className="row rows" style={{ marginLeft: "2px" }}>
            <div className="col-1">
              <img src={HeaderIcons} alt="Header Icon" width="45" height="45" />
            </div>
            <div
              className="col-9"
              style={{ marginTop: "10px", marginLeft: "-3%" }}
            >
              <p style={{ fontSize: "20px", color: "#18275A" }}>
                User Management
              </p>
            </div>
            <div
              className="col-2"
              style={{ marginTop: "10px", marginBottom: "-50px" }}
            >
              <Button
                id="demo-customized-button"
                variant="contained"
                disableElevation
                onClick={() => setOpen(true)}
                style={{
                  marginLeft: "30px",
                  textTransform: "none",
                  width: "150px",
                  transition: "background-color 0.3s, color 0.3s",
                  backgroundColor: "#1976D2",
                  color: "#FFFFFF",
                  "&:hover": {
                    backgroundColor: "#1565C0",
                  },
                }}
              >
                Add User
              </Button>
            </div>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <div className="row">
          <div className="col-12">
            <ManagerManagement />
          </div>
        </div>
      </Grid>
      <AddManager open={open} setOpen={setOpen} />
    </>
  );
}

export default Manager;
